import React from 'react';
import { Row, Col } from 'react-bootstrap';

import { Text } from 'v3/components';
import { formatBoolean } from 'v3/utils/formatter';

import { useCompany } from '../../shared/context';

export default function IntegrationTruckpad() {
  const company = useCompany();

  const truckpad = company.data?.integrations?.find(
    (integration) => integration.slug === 'TRUCKPAD',
  );

  return (
    <>
      <Row>
        <Col xs={12} md={6}>
          <Text type="label" color="dark">
            Integração Truckpad
          </Text>
          <Text type="regular" color="gray" as="p" className="mt-2">
            {formatBoolean(truckpad)}
          </Text>
        </Col>
      </Row>
      {!!truckpad && (
        <Row>
          <Col xs={12}>
            <Text type="label" color="dark">
              Token
            </Text>
            <Text type="regular" color="gray" as="p" className="mt-2">
              {truckpad?.client_secret || '-'}
            </Text>
          </Col>
          <Col xs={12}>
            <Text type="label" color="dark">
              Usuário
            </Text>
            <Text type="regular" color="gray" as="p" className="mt-2">
              {truckpad?.username || '-'}
            </Text>
          </Col>
        </Row>
      )}
    </>
  );
}
